/**
 * Sets a cookie based on the values given
 *
 * @param name - Name of the cookie
 * @param value - What value will be stored in the cookie
 * @param days - Amount of days before the cookie expires
 */
function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime( date.getTime() + (
      days * 24 * 60 * 60 * 1000
    ) );
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (
    value || ''
  ) + expires + '; path=/';
}

/**
 * Gets a cookie based on the name
 *
 * @param name - Name of the cookie
 * @returns {string|null}
 */
function getCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split( ';' );
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt( 0 ) == ' ') {
      c = c.substring( 1, c.length );
    }
    if (c.indexOf( nameEQ ) == 0) {
      return c.substring( nameEQ.length, c.length );
    }
  }
  return null;
}

/**
 * Force erase a cookie
 *
 * @param name - Name of the cookie
 */
function eraseCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export default {
  init() {
  },
};